import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getOrderExpiredReports(params: any): AxiosPromise {
    return EndPointService.get('/order-expired-report', { params });
}

function getOrderExpiredReport(id: number | string): AxiosPromise {
    return EndPointService.get(`/orderExpiredReports/${id}`);
}

function deleteOrderExpiredReport(id: number | string): AxiosPromise {
    return EndPointService.delete(`/orderExpiredReports/${id}`);
}

function createOrderExpiredReport(payload: any): AxiosPromise {
    return EndPointService.post('/orderExpiredReports', payload);
}

function updateOrderExpiredReport(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/orderExpiredReports/${id}`, { ...payload });
}
export default {
    getOrderExpiredReports,
    getOrderExpiredReport,
    deleteOrderExpiredReport,
    createOrderExpiredReport,
    updateOrderExpiredReport,
};
